module.exports = __webpack_public_path__ + "img/uk_failure_2.ca093674.png";